module.exports = __webpack_public_path__ + "static/5-ways-it-sector-will-be-influenced-by-coronavirus-7687658dbd4a67a67a9b1d4ef8df80a5.jpg";